import { ZodArrayError } from "@/types/app";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { ZodError } from "zod";

export const getImageUrl = (image: string) => {
    if (!image) return image;
    if (image.startsWith("http") || image.startsWith("blob:http")) return image;
    return `${window.origin}${image}`;
};

export const separadorMiles = (
    num: number | null | string,
    separator: string = "."
) => {
    return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

export const PattyToast = async ({
    message,
    icon,
    time = 2000,
    bg = "#FFFFFF",
    iconHtml = "",
}: {
    message: string;
    icon: "success" | "error" | "info" | "warning" | "question";
    time?: number;
    bg?: string;
    iconHtml?: string;
}) => {
    let options: SweetAlertOptions;

    if (iconHtml !== "") {
        let validIcon: string = iconHtml;
        //check if iconHtml is a valid url or a path
        const isUrl = validIcon.includes("http");
        if (!isUrl) {
            validIcon = `${window.origin}${iconHtml}`;
        }
        const customIcon = `<div><img src="${validIcon}" /></div>`;
        //tittle color

        options = {
            iconHtml: customIcon,
            title: message,
            position: "top",
            showConfirmButton: false,
            background: bg,
            timer: time,
            toast: true,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            },
            //change backgroud to this class swal2-timer-progress-bar
            customClass: {
                timerProgressBar: "toastBarColor",
                icon: "toastIconColor",
            },
            iconColor: "RGBA(0,203,205,0.3)",
        };
    } else {
        options = {
            icon: icon,
            title: message,
            position: "top",
            showConfirmButton: false,
            background: bg,
            timer: time,
            toast: true,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            },
            //change backgroud to this class swal2-timer-progress-bar
            customClass: {
                timerProgressBar: "toastBarColor",
                icon: "toastIconColor",
            },
            iconColor: "RGBA(0,203,205,0.3)",
        };
    }

    const Toast = Swal.mixin(options);
    Toast.fire({
        icon: icon,
        title: message,
    });
};

export const PattyAlert = async ({
    title,
    message = "",
    icon,
    bg = "#FFFFFF",
    iconHtml = "",
    timer = 0,
    html = false,
}: {
    title: string;
    message?: string;
    icon: "success" | "error" | "info" | "warning" | "question";

    bg?: string;
    iconHtml?: string;
    timer?: number;
    html?: boolean;
}) => {
    let options: SweetAlertOptions;

    if (iconHtml !== "") {
        let validIcon: string = iconHtml;
        //check if iconHtml is a valid url or a path
        const isUrl = validIcon.includes("http");
        if (!isUrl) {
            validIcon = `${window.origin}${iconHtml}`;
        }
        const customIcon = `<div><img src="${validIcon}" /></div>`;
        options = {
            iconHtml: customIcon,
            title: title,
            icon: icon,
            background: bg,
            customClass: {
                icon: "toastIconColor",
            },
            showCancelButton: false,
            iconColor: "RGBA(0,203,205,0.3)",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#790546",
        };
    } else {
        options = {
            title: title,
            icon: icon,
            background: bg,
            showCancelButton: false,
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#790546",
        };
    }

    if (timer > 0) {
        options.timer = timer;
        options.showCancelButton = false;
        options.showConfirmButton = false;
    }

    if (html === true) {
        options.html = message;
    } else {
        options.text = message;
    }

    return Swal.fire(options);
};

export const PattyAlertQuestion = async ({
    title,
    message = "",
    icon,
    bg = "#FFFFFF",
    iconHtml = "",
}: {
    title: string;
    message?: string;
    icon: "success" | "error" | "info" | "warning" | "question";

    bg?: string;
    iconHtml?: string;
}): Promise<Boolean> => {
    let options: SweetAlertOptions;

    if (iconHtml !== "") {
        let validIcon: string = iconHtml;
        //check if iconHtml is a valid url or a path
        const isUrl = validIcon.includes("http");
        if (!isUrl) {
            validIcon = `${window.origin}${iconHtml}`;
        }
        const customIcon = `<div><img src="${validIcon}" /></div>`;
        options = {
            iconHtml: customIcon,
            title: title,
            text: message,
            icon: icon,
            background: bg,
            customClass: {
                icon: "toastIconColor",
            },
            showCancelButton: true,
            iconColor: "RGBA(0,203,205,0.3)",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#790546",
            //cancel button color light red
            cancelButtonColor: "#FF6B57",
        };
    } else {
        options = {
            title: title,
            text: message,
            icon: icon,
            background: bg,
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#790546",
            cancelButtonColor: "#FF6B57",
        };
    }

    return Swal.fire(options).then((result) => result.isConfirmed);
};

export const delay = async (ms: number) => {
    return new Promise((res) => setTimeout(res, ms));
};

export const formater = new Intl.ListFormat("es", {
    style: "long",
    type: "conjunction",
});

export const capturarError = async (error: any) => {
    if (error instanceof ZodError) {
        const listOfErrors: ZodArrayError[] = [];
        for (const issue of error.issues) {
            if (!listOfErrors.some((err) => err.field === issue.path[0])) {
                listOfErrors.push({
                    field: issue.path[0],
                    message: issue.message,
                });
            }
        }
        const message = ` ${formater.format(
            listOfErrors.map((item) => item.message)
        )}`;
        await PattyAlert({
            title: "Por favor revisa lo siguiente:",
            message: message,
            icon: "warning",
        });
    } else {
        // Verifica si error tiene una propiedad response
        if (error.response) {
            // Verifica si el estado es 400
            if (error.response.status === 400) {
                const dataError = error.response.data;
                if (dataError.type === "validation") {
                    const listOfErrors: string[] = [];
                    Object.keys(dataError.message).forEach(function (key) {
                        listOfErrors.push(dataError.message[key][0]);
                    });
                    const message = ` ${formater.format(
                        listOfErrors.map((item) => item)
                    )}`;

                    await PattyAlert({
                        title: "Por favor revisa lo siguiente:",
                        message: message,
                        icon: "warning",
                    });
                } else {
                    // Detectar si es un mensaje de fecha mínima para usar un tono más amigable
                    const esMensajeFecha = dataError.message?.includes("fecha mínima") || 
                                         dataError.message?.includes("fecha de reserva");
                    
                    await PattyAlert({
                        title: esMensajeFecha ? "📅 Selección de Fecha" : "Aviso",
                        message: dataError.message,
                        icon: esMensajeFecha ? "info" : "warning",
                    });
                }
            } else {
                await PattyAlert({
                    title: "Ups, algo salió mal",
                    message: "Por favor intenta nuevamente o contáctanos si el problema persiste",
                    icon: "warning",
                });
            }
        } else {
            // Manejo de errores en caso de que no haya respuesta
            await PattyAlert({
                title: "Problema de conexión",
                message: "Verifica tu conexión a internet e intenta nuevamente",
                icon: "warning",
            });
        }
    }
};

export const formatDate = (timestamp: string) => {
    const date = new Date(timestamp);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    return `${day}/${month}/${year}`;
};

export const imagenesMediaQuery = (imagen: string, resolucion: string) => {
    if (imagen.startsWith("http://127")) {
        const separarImagen = imagen.split(".");
        return `${separarImagen[0]}.${separarImagen[1]}.${separarImagen[2]}.${separarImagen[3]}-${resolucion}.${separarImagen[4]}`;
    } else if (imagen.startsWith("https://prueba.refreshchile.cl")) {
        const separarImagen = imagen.split(".");
        return `${separarImagen[0]}.${separarImagen[1]}.${separarImagen[2]}-${resolucion}.${separarImagen[3]}`;
    } else if (imagen.startsWith("https://pattycarino.cl")) {
        const separarImagen = imagen.split(".");
        return `${separarImagen[0]}.${separarImagen[1]}.${separarImagen[2]}-${resolucion}.${separarImagen[3]}`;
    }
};
